var _defs, _text, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveUpIkonFjarrvarmeEnergi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 768 766",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:134.07px;font-family:Barlow-Bold, Barlow;font-weight:700;letter-spacing:0.08em;}"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(221.52 567.83)"
  }, "MWH")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M461.69,279.4c.88,24.66-14.71,89.31-51.34,89.31a32.77,32.77,0,0,1-32.77-32.77c0-43.38,50.34-33.74,50.34-83,1.74-46.59-47.17-78.91-47.17-78.91,0,45.13-22.72,60-39.31,75.7-2.62,2.33-17.76,15.44-18.64,16l-.29.29a98.73,98.73,0,0,0-35.23,75.7,97,97,0,0,0,18.34,57.36s1.46,2,4.08,5.24a94.64,94.64,0,0,0,27.37,23c12.23,7.86,28.24,13.68,48,13.68h3.79c3.2,0,6.4-.29,9.32-.58l.29-.29c1.74-.29,3.78-.59,5.53-.88.29,0,.58.29.87,0a140.26,140.26,0,0,0,15.73-4.36c.29,0,.58-.3.87-.3a100.45,100.45,0,0,0,59.69-64A102.47,102.47,0,0,0,485.27,342a35.94,35.94,0,0,0,.3-5.53C481.78,294,461.69,279.4,461.69,279.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveUpIkonFjarrvarmeEnergi);
export default __webpack_public_path__ + "static/media/SaveUp_Ikon-fjarrvarme-energi.8e00e26d37d33da7641a3c28da8c8cc0.svg";
export { ForwardRef as ReactComponent };